import merge from "lodash/merge";
import { DeepPartial } from "lightweight-charts";
import { ChartCandle, AreaSeriesOptions, AreaData } from "../chart.typings";
import BaseChartSeries from "./baseSeries";
import { areaSeriesOptions } from "../../../assets/constants";
import { IndicatorOutput_OutputStyle } from "../../../proto/generated/indicator";
import { evaluateExpression } from "../../../util/safeExpressionEval";

class AreaSeries extends BaseChartSeries<AreaData, AreaSeriesOptions> {

    addSeriesToChart() {
        return this.chart.chartApi.addAreaSeries(this.seriesOptions)
    }
    getDefaultOptions(): AreaSeriesOptions {
        const { thickness } = this.config;
        const options: AreaSeriesOptions = {
            lineWidth: thickness || areaSeriesOptions.lineWidth,
        }
        return merge({ ...areaSeriesOptions }, options, this.options)
    }

    onOptionsUpdate(options: DeepPartial<AreaSeriesOptions>): void {
        if ('source' in options) {
            this._setData(this.rawData)
        }
    }
    
    generateSeriesData(data: ChartCandle[], metadata: Record<string, any> = {}): AreaData[] {
        const result: AreaData[] = [];
        const open: number[] = new Array(data.length);
        const close: number[] = new Array(data.length);
        const series: number[] = new Array(data.length);


        const {color} = metadata;
        const isColorHexCode = color && RegExp(/^#[0-9a-fA-F]{6}([0-9a-fA-F]{2})?$/).test(color)
        const source = this.seriesOptions.source

        data.forEach((candle, index) => {
            if (candle[source] === undefined) return;
            let candleColor = color;
            if (isNaN(candle[source] as number) && this.config.style === IndicatorOutput_OutputStyle.WITH_BREAKS) {
                candleColor = "transparent"
            } else if (!isColorHexCode && candleColor) {
                open[index] = candle.open;
                close[index] = candle.close;
                series[index] = candle.series || 0
                candleColor = evaluateExpression<string>(color, { open, close, series, candle, index })
            }

            result.push({
                ...candle,
                value: candle[source] as number,
                topColor: candleColor && (candleColor == "transparent" || !isColorHexCode) ? candleColor : undefined,
                bottomColor: candleColor && (candleColor == "transparent" || !isColorHexCode) ? candleColor : undefined
            })

        })

        return result;
    }

}

export default AreaSeries;